import { Component, OnInit } from '@angular/core';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';

@Component({
  selector: 'app-voyager-footer',
  templateUrl: './voyager-footer.component.html',
  styleUrls: ['./voyager-footer.component.scss']
})
export class VoyagerFooterComponent implements OnInit {
  translate: TranslateService;
  enLang: Boolean;
  frLang: Boolean = true;

  switchLanguage = (lang: string) => {
    this.translate.use(lang);
    // this.frLang = !this.frLang;
    // this.enLang = !this.enLang;
  }
  constructor(
    translate: TranslateService
  ) {
    this.translate = translate;
    translate.setDefaultLang('fr');
  }

  ngOnInit() {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {

      if (this.translate.currentLang === 'en') {
        this.enLang = true;
        this.frLang = false;

      } else if (this.translate.currentLang === 'fr') {
        this.frLang = true;
        this.enLang = false;
      }
      console.log(this.enLang, this.frLang);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/partials/voyager-footer/voyager-footer.component.ts